import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import '../aboutstyle.css' ;
import '../style.css';
import Aboutimage from '../assets/about_image.png' ;
import WhyAbout from "../components/WhyAbout";
import Wdata from "../components/whyaboutdata";
import Chairperson from "../assets/Ratna_Chadha.png";
import Ceo from "../assets/varun_chadha.png";
import Saleshead from "../assets/Prashant_sharma.jpeg";
import Ophead from "../assets/Richa_chawla.png";
import { Helmet } from 'react-helmet';
import ScrolltoTop from "../components/ScrolltoTop";



const About = () => {
    return(
        <>
          <Helmet>
                <title>About TIRUN | 30+ Years of Cruise Excellence in India</title>
                <meta name="description" content="As pioneers of cruising in India and with 30+ years of cruise leadership, TIRUN is the exclusive India partner of Royal Caribbean Group. Discover our journey, legacy, and passion for redefining cruise travel." />
              </Helmet>
        <div className="About-container">
            <Navbar/>
             <div className="offer-alert">
               <div>
                   <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                  <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                  <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                   <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                   <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
               </div>
               <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
            </div>

            <div className="about-section">
                <div>
                  <img src={Aboutimage} alt="About Tirun" />
                </div>
                <div className="about-content">
                    <h1>About TIRUN</h1>
                    <p><span style={{fontWeight:'700'}}>TIRUN Travel Marketing is the pioneer of cruises in India and exclusively represents four cruise brands, three owned by the Royal Caribbean Group, namely, Royal Caribbean International, Celebrity Cruises and Silversea, and Azamara Cruises. </span> We continue to successfully undertake exclusive sales and marketing through various distribution channels, be it tour operators and travel agents, or online mediums, and manage government relations for our brands while also providing operational support.<br></br><br></br>

Incepted as Discover the World Marketing in 1991, and later rechristened to <span style={{fontWeight:'700'}}>TIRUN,</span> in the year 2001, the Company has introduced many acclaimed international brands to our parts of the word, some of which include US Airways, Hyatt Hotels, Hertz and Universal Studio’s and of course the Royal Caribbean Group.<br></br><br></br>

Headquartered in New Delhi, the company has on-ground presence pan India.<br></br><br></br>

At <span style={{fontWeight:'700'}}>TIRUN,</span> we are super passionate about cruises and with the world mostly covered by water, if you haven’t cruised, you haven’t seen the world….so come and Just Cruise with Us!</p>
                </div>
            </div>


            <div className="Why-about-us" >
                <h4>Why us</h4>
                <h2>Cruising Made Easy</h2>
                <div>
                    <div className="why-card">

                    <WhyAbout img={Wdata[0].img} heading={Wdata[0].heading} para={Wdata[0].para} />
                    <WhyAbout img={Wdata[1].img} heading={Wdata[1].heading} para={Wdata[1].para} />
                    <WhyAbout img={Wdata[2].img} heading={Wdata[2].heading} para={Wdata[2].para} />

                    </div>
                    <div className="why-card">
                    <WhyAbout img={Wdata[3].img} heading={Wdata[3].heading} para={Wdata[3].para} />
                    <WhyAbout img={Wdata[4].img} heading={Wdata[4].heading} para={Wdata[4].para} />
                    <WhyAbout img={Wdata[5].img} heading={Wdata[5].heading} para={Wdata[5].para} />

                    </div>
                </div>
            </div>


            <div className="result-count">
                <div>
                    <h2>300+</h2>
                    <h5>Destinations</h5>
                </div>

                <div>
                <h2>30+</h2>
                <h5>Years Of Smooth Sailing</h5>
                </div>

                <div>
                <h2>1000+</h2>
                <h5>Itineraries</h5>
                </div>

                <div>
                <h2>5,00,000+</h2>
                <h5>Happy Customers</h5>
                </div>
            </div>

            <div className="Tirun-Team">
    <h2>Our Team</h2>
    <h3>Meet the Team</h3>
    <div className="Team-name">
        <div>
            <a href="https://www.linkedin.com/in/ratna-chadha-3a3b92137/" target="_blank" rel="noopener noreferrer">
                <img src={Chairperson} style={{ width: '164px' }} alt="Chairperson of Tirun" />
                <h2>Ratna Chadha</h2>
                <h5>Chairperson & Co-founder</h5>
                <i className="fab fa-linkedin" style={{ fontSize: '24px', display: 'none' }}></i>
            </a>
        </div>
        <div>
            <a href="https://www.linkedin.com/in/varun-chadha-73061820/" target="_blank" rel="noopener noreferrer">
                <img src={Ceo} style={{ width: '164px' }} alt="CEO of Tirun" />
                <h2>Varun Chadha</h2>
                <h5>CEO</h5>
                <i className="fab fa-linkedin" style={{ fontSize: '24px', display: 'none' }}></i>
            </a>
        </div>
        <div>
            <a href="https://www.linkedin.com/in/prashant-sharma-3a703b4a/" target="_blank" rel="noopener noreferrer">
                <img src={Saleshead} alt="Head of Sales Tirun" style={{ width: '164px' }} />
                <h2>Prashant Sharma</h2>
                <h5>Head of Sales</h5>
                <i className="fab fa-linkedin" style={{ fontSize: '24px', display: 'none' }}></i>
            </a>
        </div>
        <div>
            <a href="https://www.linkedin.com/in/richa-chawla-30b16678/" target="_blank" rel="noopener noreferrer">
                <img src={Ophead} style={{ width: '164px' }} alt="Operation Head Tirun" />
                <h2>Richa Chawla</h2>
                <h5>Operations Head</h5>
                <i className="fab fa-linkedin" style={{ fontSize: '24px', display: 'none' }}></i>
            </a>
        </div>
    </div>
</div>
{/* 
<<<<<<< HEAD
                </div>
                <div>
                <img src={Ceo} style={{width:'164px'}} alt="Ceo of Tirun"></img>
                    <h2>Varun Chadha</h2>
                    <h5>CEO</h5>
                </div>

                <div>
                    <img src={Saleshead} alt="Head of sales Tirun" style={{width:'164px'}}></img>
                    <h2>Prashant Sharma</h2>
                    <h5>Head of Sales</h5>
                </div>

                <div>
                    <img src={Ophead} style={{width:'164px'}} alt="Operation head Tirun"></img>
                    <h2>Richa Chawla</h2>
                    <h5>Operations Head</h5>
                </div>
                </div> */}

            </div>
            <ScrolltoTop/>

            <Footer/>

     
        </>
    );
}


export default About ;